import React from "react";
import { Zap, Link2, Waves, GitMerge, Fingerprint, Filter } from "lucide-react";

export default function ActivateStep({ channels, channelId, onChange, summary, title = "Step 7 — Activate", description = "Review your full pipeline, then publish the Segment to the right destination for this business scenario." }) {
  return (
    <div>
      <h3 className="font-heading font-semibold text-white mb-1">{title}</h3>
      <p className="text-sm text-slate-400 mb-4">{description}</p>

      <div className="glass-panel rounded-2xl p-5 mb-5 border border-white/10" data-testid="activate-pipeline-review">
        <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-3">Pipeline Review</p>
        <div className="flex items-center gap-2 flex-wrap text-xs text-slate-300">
          {[
            { icon: Link2, label: `${summary.connectedCount} sources` },
            { icon: Waves, label: `${summary.streamsCount} streams` },
            { icon: GitMerge, label: `${summary.mappedCount} fields mapped` },
            { icon: Fingerprint, label: `${summary.identityCount} identity rules` },
            { icon: Filter, label: "1 segment + 1 insight" },
          ].map((it, i) => {
            const Icon = it.icon;
            return (
              <span key={i} className="flex items-center gap-1.5 bg-white/5 px-2.5 py-1 rounded-full">
                <Icon className="w-3 h-3 text-indigo-400" /> {it.label}
              </span>
            );
          })}
        </div>
      </div>

      <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-2">Choose Activation Target</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-testid="activation-channels">
        {channels.map((c) => (
          <button
            key={c.id} onClick={() => onChange(c.id)} data-testid={`activation-channel-${c.id}`}
            className={`flex items-center gap-2 p-3.5 rounded-lg border text-sm transition-colors ${
              channelId === c.id ? "border-indigo-400 bg-indigo-400/10 text-indigo-200" : "border-white/10 text-slate-300 hover:border-white/25"
            }`}
          >
            <Zap className="w-4 h-4 shrink-0" /> {c.name}
          </button>
        ))}
      </div>
    </div>
  );
}
